import { mmfReturnDisclosureParagraphs } from '@common/react/goals';
import { Paragraph } from '../common/Typography';

const ReturnDisclosureMMF = () => (
    <>
        {mmfReturnDisclosureParagraphs.map((str, idx) => (
            <Paragraph key={idx}>{str}</Paragraph>
        ))}
    </>
);

export default ReturnDisclosureMMF;
